import { useState, useEffect } from "react";
import "./StorageDiagram.css";
import BuildingA from "./BuildingA";
import BuildingB from "./BuildingB";
import BuildingC from "./BuildingC";

export default function StorageDiagram({tableData}) {
  const [units, setUnits] = useState({});

  useEffect(() => {
    const newUnits = tableData.reduce((acc, unit) => {
      acc[unit.unit] = {
        renterName: unit.name || "",
        isRented: unit.name && unit.name.trim() !== "",
      };
      return acc;
    }, {});
    setUnits(newUnits);
  }, [tableData]);

  const toggleUnit = (unitNumber) => {
    setUnits((prev) => ({
      ...prev,
      [unitNumber]: {
        ...prev[unitNumber],
        isRented: !prev[unitNumber]?.isRented,
      },
    }));
  };

  const setRenter = (unitNumber, name) => {
    setUnits((prev) => ({
      ...prev,
      [unitNumber]: {
        ...prev[unitNumber],
        renterName: name,
      },
    }));
  };

  return (
    <div className="site-map">
     <div className="highway">
        <span className="highway-label">HWY 377</span>
    </div>

      <div className="buildings">
        <div className="top-row">
          <BuildingA units={units} onToggle={toggleUnit} onName={setRenter} />
          <BuildingB units={units} onToggle={toggleUnit} onName={setRenter} />
        </div>

        <div className="bottom-row">
          <BuildingC units={units} onToggle={toggleUnit} onName={setRenter} />
        </div>
      </div>
    </div>
  );
}
